<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
@if (devicesToShow) {
    <div class="bom-report bom-report--device-settings">
        <div class="bom-report__navigation-line">
            <div class="sidebar">
                <button (click)="showDevicesList = !showDevicesList" windeTransparent>
                    <sui-svg-icon icon="bars" windeGrey />
                    <span class="title">Devices list</span>
                </button>
            </div>
            <div class="nav-buttons">
                <div class="btn-prev">
                    <button (click)="switchDevice(-1)" class="bom-report__navigation-btn" windeTransparent>
                        <sui-svg-icon icon="angle-left" windeGrey />
                        <span>Previous device</span>
                    </button>
                </div>
                <div class="btn-next">
                    <button (click)="switchDevice(1)" class="bom-report__navigation-btn" windeTransparent>
                        <span>Next device</span>
                        <sui-svg-icon icon="angle-right" windeGrey />
                    </button>
                </div>
            </div>
            <div class="btn-close">
                <winde-ctx-sensitive-help placement="left" tooltipTextPath="projectView.export.bomReview.return">
                    <button (click)="closeConfigWindow()" windeActionIcon>
                        <sui-svg-icon icon="cross" windeGrey />
                    </button>
                </winde-ctx-sensitive-help>
            </div>
        </div>

        <div class="bom-report__data">
            @if (activeDevice) {
                <div [ngClass]="{ 'bom-report__body--with-sidebar': showDevicesList }" class="bom-report__body">
                    @if (showDevicesList) {
                        <aside class="bom-report__sidebar">
                            <ul class="bom-report__node-list">
                                @for (device of devicesToShow; track device; let deviceIndex = $index) {
                                    <li
                                        (click)="selectDevice(deviceIndex)"
                                        (keydown)="selectDevice(deviceIndex)"
                                        [disabled]="tooltipsAreDisabled"
                                        [ngClass]="{
                                            active:
                                                device.typeProductId === activeDevice.typeProductId &&
                                                device.antenna === activeDevice.antenna &&
                                                device.layerIndex === activeDevice.layerIndex
                                        }"
                                        [showDelay]="2000"
                                        position="right"
                                        suiTooltip
                                        tooltipText="{{ device.typeName }}"
                                    >
                                        {{ device.typeName }} {{ layersObject ? '(' + layersObject[device.layerIndex] + ')' : '' }}
                                    </li>
                                }
                            </ul>
                        </aside>
                    }
                    <form [formGroup]="editForm" [windeDisableFormControls]="editForm" class="bom-report__content">
                        <h4>
                            <span [windeProductNameLink]="activeDevice.typeName" class="device-name">{{ activeDevice.typeName }}</span> ({{
                                activeDeviceAntennaName
                            }})
                            @if (layersObject) {
                                <br />
                                Layer {{ layersObject[activeDevice.layerIndex] }}
                            }
                        </h4>
                        <div class="grid">
                            <!-- BODY -->
                            @for (input of configInputs; track input) {
                                <div class="grid-row">
                                    <div class="grid-row__cell">
                                        <span [attr.for]="input.key" class="form-label">{{ input.label }}:</span>
                                    </div>
                                    <div class="grid-row__cell">
                                        <winde-reactive-input [form]="editForm" [input]="input"></winde-reactive-input>
                                    </div>
                                </div>
                            }
                        </div>
                    </form>
                </div>
            }
        </div>
    </div>
}
